module.exports = __webpack_public_path__ + "img/icon-ezwrite6-googleclassroom.a5488a07.svg";